<template>
  <div :class="'col-md-' + col" class="selectmulti">
    <label class="typo__label">{{ label }} <span v-if="isRequired">*</span></label>
    <!--    <multiselect :name="name" v-model="selectedOptions" :options="options" :multiple="true" :close-on-select="false"-->
    <!--                 :clear-on-select="false"-->
    <!--                 :preserve-search="true" placeholder="Selecione os itens" label="name" track-by="name"-->
    <!--                 :preselect-first="true">-->
    <!--      <template slot="selection" slot-scope="{ values, search, isOpen }">-->
    <!--            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">-->
    <!--              {{ values.length }} itens selecionados-->
    <!--            </span>-->
    <!--      </template>-->
    <!--    </multiselect>-->
    <VueMultiselectComponent
      v-model="selectedOptions"
      :options="options"
    />
    <span class="selectmulti-error" v-if="inputError">Selecione algum item *</span>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueMultiselectComponent from 'vue-multiselect-component'

export default {
  name: "inputMultiSelect",
  components: {
    VueMultiselectComponent,
    Multiselect
  },
  props: {
    label: {
      required: true,
    },
    options: {
      required: true,
    },
    col: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    inputError: {
      default: false,
    },
    name: {
      default: ''
    }
  },
  data() {
    return {
      selectedOptions: [],
    }
  },
  watch: {
    selectedOptions(newValue, oldValue) {
      this.$emit('selectedOptions', newValue)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

.typo__label {
  font-weight: 400;
  font-size: 14px;
  color: #191919;
  margin-bottom: 4px;

  span {
    font-weight: 400;
    font-size: 14px;
    color: #FF445D;
  }
}

.multiselect {
  font-weight: 400;
  font-size: 17px;
  color: #3A424E;
  cursor: pointer;

  &__tags {
    background: #EEF2F7;
    border: 1px solid #EEF2F7;
    transition: .2s;
    border-radius: 4px !important;
    padding: 6px 40px 0 8px;
    min-height: 40px;
    max-height: 40px;

    &:hover {
      border: 1px solid #CACACA;
    }
  }

  &__tags > &__single {
    background: #EEF2F7;
    color: #3A424E;
    font-weight: 400;
    font-size: 17px;
    padding-top: 3px;
    padding-left: 0;
  }

  &__tags > &__spinner {
    background: #EEF2F7;
  }

  &__tags > &__placeholder {
    color: #7E8DA7;
    font-weight: 400;
    font-size: 17px;
    padding-top: 0;
  }

  &__tags > &__input {
    padding-top: 3px;
    padding-left: 0;
    background: #EEF2F7;

    &::placeholder {
      color: #7E8DA7;
      font-weight: 400;
      font-size: 17px;
    }
  }

  &__select {
    &:before {
      border-color: #4E4F50 transparent transparent;
    }
  }

  &__content-wrapper {
    border: 1px solid #CACACA;
    border-radius: 4px !important;
    background: #FFFFFF;
  }

  &__content-wrapper > &__content > &__element > &__option {
    background: #EEF2F7;
    white-space: pre-line;
    font-size: 14px;
  }

  &__content-wrapper > &__content > &__element > &__option--highlight {
    background: #E6E9EC;
    color: #3A424E;

    &::after {
      background: transparent;
      color: transparent;
      content: "" !important;
    }
  }

  &__content-wrapper > &__content > &__element > &__option--selected {
    background: #D5DFEB;

    &::after {
      background: transparent;
      color: transparent;
      content: "" !important;
    }
  }

  &__content-wrapper > &__content > &__element > .multiselect__option--highlight.multiselect__option--selected {
    background: #D5DFEB;

    &::after {
      background: transparent;
      color: transparent;
      content: "" !important;
    }
  }
}

.selectmulti {
  position: relative;

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputMultiSelect.vue